import { commonServerInstance } from '@/utilities/instances'
import type { ReasonCategoryOption } from '@/service/orderDownload'

export const getClaimDataReasonCategories = async (): Promise<
  ReasonCategoryOption[]
> => {
  const response = await commonServerInstance.get(
    '/api/v1/claim-data/reason-categories'
  )
  return response?.data?.data ?? []
}

interface ClaimDataExportParams {
  file: File
  reason_category: string
  justification: string
}

export const uploadClaimDataExport = async (params: ClaimDataExportParams) => {
  const formData = new FormData()
  formData.append('file', params.file)
  formData.append('reason_category', params.reason_category)
  formData.append('justification', params.justification)

  const response = await commonServerInstance.post(
    '/api/v1/claim-data/export',
    formData
  )
  return response?.data?.data
}
